module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobilearticleblock"
  }, [(this.infoline) ? _c('div', {
    staticClass: "mobilearticleflexcontainer"
  }, [_c('div', {
    staticClass: "mobilearticletext"
  }, [_vm._v("\n      " + _vm._s(_vm.art.title) + ", pp. " + _vm._s(_vm.art.firstpage) + "-" + _vm._s(_vm.art.lastpage) + " in " + _vm._s(_vm.art.editor) + ", ed., " + _vm._s(_vm.art.book) + "  (with " + _vm._s(_vm.art.coauthor) + ")"), _vm._v(" (" + _vm._s(_vm.art.year) + ").\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mobilearticleiconbuttons"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.abs()
      }
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/file-text.svg")
    }
  })]), _vm._v(" "), (_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()])]) : _c('div', [_c('hr'), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.art.title))]), _vm._v(" "), _c('h6', [_vm._v("Abstract")]), _vm._v(" "), (_vm.art.abstract) ? _c('p', [_vm._v(_vm._s(_vm.art.abstract))]) : _c('p', [_vm._v("Sorry, I don't have an abstract for this publication.")]), _vm._v(" "), _c('p', [(_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()]), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Citation")]), _vm._v(" "), _c('p', [_c('newcitation', {
    attrs: {
      "art": _vm.art
    }
  })], 1), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.line()
      }
    }
  }, [_vm._v("\nClose abstract.\n")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1a0f4e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pubs/mobilechapterrow.vue
// module id = 187
// module chunks = 0